export enum MessageKey {
  SupportEmailAddress,
  SupportEmailAddressLink,
}
